module.exports = __webpack_public_path__ + "static/an-american-marriage-oprahs-book-club-280ded507551438974ae5cbb46d8e4a3.jpg";